const menu = {
    label: 'Consultas Docflow',
    icon: 'pi pi-fw pi-list',
    to: '/consultas/processos',
    rules: ['CONSULTAS-00'],
};

export default menu;
